import { render, staticRenderFns } from "./ContactsListWidget.vue?vue&type=template&id=21900792&scoped=true"
import script from "./ContactsListWidget.vue?vue&type=script&lang=js"
export * from "./ContactsListWidget.vue?vue&type=script&lang=js"
import style0 from "./ContactsListWidget.vue?vue&type=style&index=0&id=21900792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21900792",
  null
  
)

export default component.exports